import 'bootstrap/dist/css/bootstrap.min.css';
import './TestForm.css';
import Form from "@rjsf/mui";
import validator from "@rjsf/validator-ajv6";

const dateNow = new Date().toISOString().slice(0,10)

let onSubmit = ({formData}) => console.log(formData);

const schema = {
    "title": "Form",
    "description": "Questa è il json di jotform",
    "type": "object",
    "properties": {
        "fototessera":{
            "type":"string",
            "format":"data-url",
            "title":"Fototessera",
            "description": "Fototessera",
        },
        "background": {
            "type": "number",
            "title": "Sono uno/a",
            "oneOf": [
                {"const": 1, "title": "Neo diplomato/a (Validità ai fini del progetto, entro 12 mesi)"},
                {"const": 2, "title": "Apprendista (Validità ai fini del progetto, entro 12 mesi)"},
                {"const": 3, "title": "Neo qualificato/a (Validità ai fini del progetto, entro 12 mesi)"},
                {"const": 4, "title": "Studente IV o V anno"}
            ],
        },
        "paeseDestinazione": {
            "type": "array",
            "title": "Paese di destinazione",
            "items": {
                "type": "string",
                "enum": [
                    "Lituania",
                    "Spagna",
                    "Polonia",
                    "Irlanda"
                ]
            },
            "uniqueItems": true
        },
        "domandaMaggiorenne":{
            "type":"object",
            "title": "Sei Maggiorenne?",
            "properties" : {
                "maggiorenne": {
                    "type": "boolean",
                    "title": "Sei Maggiorenne?",
                    "oneOf": [
                        {"const": true, "title": "Sì"},
                        {"const": false, "title": "No"}
                    ]
                }
            },
            "dependencies": {
                "maggiorenne": {
                    "oneOf": [
                        {
                            "properties": {
                                "maggiorenne": {
                                    "const": false
                                },
                                "consenso": {
                                    "format": "data-url",
                                    "type": "string",
                                    "title": "Consenso dei genitori"
                                }
                            },"required": [
                                "consenso"
                            ]
                        }, {
                            "properties": {
                                "maggiorenne": {
                                    "const": true
                                }
                            }
                        }
                    ]
                },
            },
            "required":[
                "maggiorenne"
            ]
        },
        "anagrafica":{
            "type": "object",
            "title": "Anagrafica",
            "properties":{
                "nome":{
                    "type":"string",
                    "title":"Nome"
                },
                "cognome":{
                    "type":"string",
                    "title":"Cognome"
                },
                "dataNascita": {
                    "type": "string",
                    "format": "date",
                    "title":"Data di Nascita"
                },
                "luogoNascita": {
                    "type": "string",
                    "title": "Luogo di Nascita"
                },
                "paeseNascita": {
                    "type": "string",
                    "title": "Paese di Nascita",
                    "default" : "Italy",
                    "enum" : ["Afghanistan","Albania","Algeria","AmericanSamoa","Andorra","Angola","Anguilla","Antarctica","AntiguaandBarbuda","Argentina","Armenia","Aruba","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia","BosniaandHerzegovina","Botswana","BouvetIsland","Brazil","BritishIndianOceanTerritory","Brunei","Bulgaria","BurkinaFaso","Burundi","Cambodia","Cameroon","Canada","CapeVerde","CaymanIslands","CentralAfricanRepublic","Chad","Chile","China","ChristmasIsland","Cocos(Keeling)Islands","Colombia","Comoros","Congo","TheDemocraticRepublicofCongo","CookIslands","CostaRica","Croatia","Cuba","Cyprus","CzechRepublic","Denmark","Djibouti","Dominica","DominicanRepublic","EastTimor","Ecuador","Egypt","England","ElSalvador","EquatorialGuinea","Eritrea","Estonia","Ethiopia","FalklandIslands","FaroeIslands","FijiIslands","Finland","France","FrenchGuiana","FrenchPolynesia","FrenchSouthernterritories","Gabon","Gambia","Georgia","Germany","Ghana","Gibraltar","Greece","Greenland","Grenada","Guadeloupe","Guam","Guatemala","Guernsey","Guinea","Guinea-Bissau","Guyana","Haiti","HeardIslandandMcDonaldIslands","HolySee(VaticanCityState)","Honduras","HongKong","Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland","Israel","IsleofMan","Italy","IvoryCoast","Jamaica","Japan","Jersey","Jordan","Kazakhstan","Kenya","Kiribati","Kuwait","Kyrgyzstan","Laos","Latvia","Lebanon","Lesotho","Liberia","LibyanArabJamahiriya","Liechtenstein","Lithuania","Luxembourg","Macao","NorthMacedonia","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","MarshallIslands","Martinique","Mauritania","Mauritius","Mayotte","Mexico","Micronesia,FederatedStatesof","Moldova","Monaco","Mongolia","Montserrat","Montenegro","Morocco","Mozambique","Myanmar","Namibia","Nauru","Nepal","Netherlands","NetherlandsAntilles","NewCaledonia","NewZealand","Nicaragua","Niger","Nigeria","Niue","NorfolkIsland","NorthKorea","NorthernIreland","NorthernMarianaIslands","Norway","Oman","Pakistan","Palau","Palestine","Panama","PapuaNewGuinea","Paraguay","Peru","Philippines","Pitcairn","Poland","Portugal","PuertoRico","Qatar","Reunion","Romania","RussianFederation","Rwanda","SaintHelena","SaintKittsandNevis","SaintLucia","SaintPierreandMiquelon","SaintVincentandtheGrenadines","Samoa","SanMarino","SaoTomeandPrincipe","SaudiArabia","Scotland","Senegal","Serbia","Seychelles","SierraLeone","Singapore","Slovakia","Slovenia","SolomonIslands","Somalia","SouthAfrica","SouthGeorgiaandtheSouthSandwichIslands","SouthKorea","SouthSudan","Spain","SriLanka","Sudan","Suriname","SvalbardandJanMayen","Swaziland","Sweden","Switzerland","Syria","Tajikistan","Tanzania","Thailand","Timor-Leste","Togo","Tokelau","Tonga","TrinidadandTobago","Tunisia","Turkey","Turkmenistan","TurksandCaicosIslands","Tuvalu","Uganda","Ukraine","UnitedArabEmirates","UnitedKingdom","UnitedStates","UnitedStatesMinorOutlyingIslands","Uruguay","Uzbekistan","Vanuatu","Venezuela","Vietnam","VirginIslands,British","VirginIslands,U.S.","Wales","WallisandFutuna","WesternSahara","Yemen","Zambia","Zimbabwe"]
                },
                "nazionalita": {
                    "type": "string",
                    "title": "Nazionalità",
                    "default": "Italiana"
                },
                "citta":{
                    "type": "string",
                    "title": "Città"
                },
                "indirizzo":{
                    "type": "string",
                    "title": "Indirizzo",
                    "description" : "Indirizzo, n°"
                },
                "cap":{
                    "type": "string",
                    "title": "Codice Postale",
                    "maxLength": 5
                },
                "paeseResidenza": {
                    "type": "string",
                    "title": "Paese di Residenza",
                    "default" : "Italy",
                    "enum" : ["Afghanistan","Albania","Algeria","AmericanSamoa","Andorra","Angola","Anguilla","Antarctica","AntiguaandBarbuda","Argentina","Armenia","Aruba","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia","BosniaandHerzegovina","Botswana","BouvetIsland","Brazil","BritishIndianOceanTerritory","Brunei","Bulgaria","BurkinaFaso","Burundi","Cambodia","Cameroon","Canada","CapeVerde","CaymanIslands","CentralAfricanRepublic","Chad","Chile","China","ChristmasIsland","Cocos(Keeling)Islands","Colombia","Comoros","Congo","TheDemocraticRepublicofCongo","CookIslands","CostaRica","Croatia","Cuba","Cyprus","CzechRepublic","Denmark","Djibouti","Dominica","DominicanRepublic","EastTimor","Ecuador","Egypt","England","ElSalvador","EquatorialGuinea","Eritrea","Estonia","Ethiopia","FalklandIslands","FaroeIslands","FijiIslands","Finland","France","FrenchGuiana","FrenchPolynesia","FrenchSouthernterritories","Gabon","Gambia","Georgia","Germany","Ghana","Gibraltar","Greece","Greenland","Grenada","Guadeloupe","Guam","Guatemala","Guernsey","Guinea","Guinea-Bissau","Guyana","Haiti","HeardIslandandMcDonaldIslands","HolySee(VaticanCityState)","Honduras","HongKong","Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland","Israel","IsleofMan","Italy","IvoryCoast","Jamaica","Japan","Jersey","Jordan","Kazakhstan","Kenya","Kiribati","Kuwait","Kyrgyzstan","Laos","Latvia","Lebanon","Lesotho","Liberia","LibyanArabJamahiriya","Liechtenstein","Lithuania","Luxembourg","Macao","NorthMacedonia","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","MarshallIslands","Martinique","Mauritania","Mauritius","Mayotte","Mexico","Micronesia,FederatedStatesof","Moldova","Monaco","Mongolia","Montserrat","Montenegro","Morocco","Mozambique","Myanmar","Namibia","Nauru","Nepal","Netherlands","NetherlandsAntilles","NewCaledonia","NewZealand","Nicaragua","Niger","Nigeria","Niue","NorfolkIsland","NorthKorea","NorthernIreland","NorthernMarianaIslands","Norway","Oman","Pakistan","Palau","Palestine","Panama","PapuaNewGuinea","Paraguay","Peru","Philippines","Pitcairn","Poland","Portugal","PuertoRico","Qatar","Reunion","Romania","RussianFederation","Rwanda","SaintHelena","SaintKittsandNevis","SaintLucia","SaintPierreandMiquelon","SaintVincentandtheGrenadines","Samoa","SanMarino","SaoTomeandPrincipe","SaudiArabia","Scotland","Senegal","Serbia","Seychelles","SierraLeone","Singapore","Slovakia","Slovenia","SolomonIslands","Somalia","SouthAfrica","SouthGeorgiaandtheSouthSandwichIslands","SouthKorea","SouthSudan","Spain","SriLanka","Sudan","Suriname","SvalbardandJanMayen","Swaziland","Sweden","Switzerland","Syria","Tajikistan","Tanzania","Thailand","Timor-Leste","Togo","Tokelau","Tonga","TrinidadandTobago","Tunisia","Turkey","Turkmenistan","TurksandCaicosIslands","Tuvalu","Uganda","Ukraine","UnitedArabEmirates","UnitedKingdom","UnitedStates","UnitedStatesMinorOutlyingIslands","Uruguay","Uzbekistan","Vanuatu","Venezuela","Vietnam","VirginIslands,British","VirginIslands,U.S.","Wales","WallisandFutuna","WesternSahara","Yemen","Zambia","Zimbabwe"]
                },
                "codiceFiscale": {
                    "type": "string",
                    "title": "Codice Fiscale"
                },
                "telefonoCellulare": {
                    "type": "number",
                    "title": "Telefono Cellulare",
                    "default" : 39,
                },
                "email": {
                    "type": "string",
                    "title": "E-mail",
                    "format": "email"
                },
                "documentoEspatrio": {
                    "type": "string",
                    "title": "Documento di identità valido per l'espatrio",
                    "enum" : ["Carta di Identità","Passaporto"]
                },
                "nDocumentoEspatrio":{
                    "type": "string",
                    "title": "n° Documento",
                },
                "dataEmissioneDocumentoEspatrio":{
                    "type": "string",
                    "format": "date",
                    "title": "Data di emissione"
                },
                "dataScadenzaDocumentoEspatrio":{
                    "type": "string",
                    "format": "date",
                    "title": "Data di scadenza"
                },
                "documentoEspatrioRilascio": {
                    "type": "string",
                    "title": "Rilasciato da"
                },

            },
            "dependencies": {
                "paeseNascita": {
                    "oneOf": [
                        {
                            "properties": {
                                "paeseNascita": {
                                    "const": "Italy"
                                },
                                "regioneNascita": {
                                    "type": "string",
                                    "title": "Regione",
                                    "enum" : ["Abruzzo","Basilicata","Calabria","Campania","Emilia Romagna","Friuli Venezia Giulia","Lazio","Liguria","Lombardia","Marche","Molise","Piemonte","Puglia","Sardegna","Sicilia","Toscana","Trentino Alto Adige","Umbria","Valle d'Aosta","Veneto"]
                                },
                                "provinciaNascita": {
                                    "type": "string",
                                    "title": "Provincia",
                                    "enum" : ["Agrigento","Alessandria","Ancona","Arezzo","Ascoli Piceno","Asti","Avellino","Bari","Barletta-Andria-Trani","Belluno","Benevento","Bergamo","Biella","Bologna","Bolzano/Bozen","Brescia","Brindisi","Cagliari","Caltanissetta","Campobasso","Carbonia-Iglesias.","Caserta","Catania","Catanzaro","Chieti","Como","Cosenza","Cremona","Crotone","Cuneo","Enna","Fermo","Ferrara","Firenze","Foggia","ForlÌ-Cesena","Frosinone","Genova","Gorizia","Grosseto","Imperia","Isernia","L'Aquila","La Spezia","Latina","Lecce","Lecco","Livorno","Lodi","Lucca","Macerata","Mantova","Massa-Carrara","Matera","Medio Campidano","Messina","Milano","Modena","Monza E Della Brianza","Napoli","Novara","Nuoro","Ogliastra","Olbia-Tempio","Oristano","Padova","Palermo","Parma","Pavia","Perugia","Pesaro E Urbino","Pescara","Piacenza","Pisa","Pistoia","Pordenone","Potenza","Prato","Ragusa","Ravenna","Reggio Di Calabria","Reggio Nell'Emilia","Rieti","Rimini","Roma","Rovigo","Salerno","Sassari","Savona","Siena","Siracusa","Sondrio","Taranto","Teramo","Terni","Torino","Trapani","Trento","Treviso","Trieste","Udine","Valle D'Aosta","Varese","Venezia","Verbano-Cusio-Ossola","Vercelli","Verona","Vibo Valentia","Vicenza","Viterbo"]
                                }
                            }
                        }
                    ]
                },
                "paeseResidenza": {
                    "oneOf": [
                        {
                            "properties": {
                                "paeseResidenza": {
                                    "const": "Italy"
                                },
                                "regioneResidenza": {
                                    "type": "string",
                                    "title": "Regione",
                                    "enum" : ["Abruzzo","Basilicata","Calabria","Campania","Emilia Romagna","Friuli Venezia Giulia","Lazio","Liguria","Lombardia","Marche","Molise","Piemonte","Puglia","Sardegna","Sicilia","Toscana","Trentino Alto Adige","Umbria","Valle d'Aosta","Veneto"]
                                },
                                "provinciaResidenza": {
                                    "type": "string",
                                    "title": "Provincia",
                                    "enum" : ["Agrigento","Alessandria","Ancona","Arezzo","Ascoli Piceno","Asti","Avellino","Bari","Barletta-Andria-Trani","Belluno","Benevento","Bergamo","Biella","Bologna","Bolzano/Bozen","Brescia","Brindisi","Cagliari","Caltanissetta","Campobasso","Carbonia-Iglesias.","Caserta","Catania","Catanzaro","Chieti","Como","Cosenza","Cremona","Crotone","Cuneo","Enna","Fermo","Ferrara","Firenze","Foggia","ForlÌ-Cesena","Frosinone","Genova","Gorizia","Grosseto","Imperia","Isernia","L'Aquila","La Spezia","Latina","Lecce","Lecco","Livorno","Lodi","Lucca","Macerata","Mantova","Massa-Carrara","Matera","Medio Campidano","Messina","Milano","Modena","Monza E Della Brianza","Napoli","Novara","Nuoro","Ogliastra","Olbia-Tempio","Oristano","Padova","Palermo","Parma","Pavia","Perugia","Pesaro E Urbino","Pescara","Piacenza","Pisa","Pistoia","Pordenone","Potenza","Prato","Ragusa","Ravenna","Reggio Di Calabria","Reggio Nell'Emilia","Rieti","Rimini","Roma","Rovigo","Salerno","Sassari","Savona","Siena","Siracusa","Sondrio","Taranto","Teramo","Terni","Torino","Trapani","Trento","Treviso","Trieste","Udine","Valle D'Aosta","Varese","Venezia","Verbano-Cusio-Ossola","Vercelli","Verona","Vibo Valentia","Vicenza","Viterbo"]
                                }
                            }
                        }
                    ]
                }
            },
            "errorMessage": {
                "properties":{
                    "nome": 'Manca il nome'
                }
            },
            "required":[
                "nome",
                "cognome",
                "dataNascita",
                "luogoNascita",
                "paeseNascita",
                "nazionalita",
                "citta",
                "indirizzo",
                "cap",
                "paeseResidenza",
                "codiceFiscale",
                "telefonoCellulare",
                "email",
                "documentoEspatrio",
                "nDocumentoEspatrio",
                "dataEmissioneDocumentoEspatrio",
                "dataScadenzaDocumentoEspatrio",
                "documentoEspatrioRilascio"
            ]
        },
        "dataAttuale":{
            "type": "string",
            "format": "date",
            "title": "Data Attuale",
            "const" : dateNow,
            "default" : dateNow
        },
        "istruzione":{
            "type":"object",
            "title": "Istruzione",
            "properties":{
                "studiSuperiori":{
                    "type": "string",
                    "title": "Studi Superiori",
                    "description" : "(Università, Master, Specializzazioni, etc.)"
                },
                "studiSuperioriDettagli":{
                    "type": "string",
                    "title": "Voto/Anno di conseguimento"
                },
                "studiSecondarie":{
                    "type": "string",
                    "title": "SCUOLE SECONDARIE II GRADO",
                    "description" : "Diploma, nome scuola e città"
                },
                "studiSecondarieDettagli":{
                    "type": "string",
                    "title": "Voto/Anno di conseguimento"
                }
            }
        },
        "altre qualifiche":{
            "type":"array",
            "title": "Altre qualifiche professionali",
            "description" : "Premi + per inserire",
            "items": {
                "type": "object",
                "title": "Qualifica",
                "properties": {
                    "titolo": {
                        "type": "string",
                        "title": "Titolo del Corso/Qualifica Rilasciata"
                    },
                    "luogo": {
                        "type": "string",
                        "title": "Organismo di formazione"
                    },
                    "anno": {
                        "type": "number",
                        "title": "Anno",
                        "maximum": 2100,
                    },
                    "durata": {
                        "type": "string",
                        "title": "Durata del Corso",
                        "description": "Mesi o Ore"
                    }
                }
            }
        },
        "competenzeLingua":{
            "type":"object",
            "title": "Competenze Linguistiche",
            "properties":{
                "linguaMadre":{
                    "type":"string",
                    "title": "Lingua Madre"
                },
                "altreLingue":{
                    "type":"array",
                    "title": "Altre Lingue",
                    "description" : "Altre lingue conosciute (A1/A2 Livello base - B1/B2 Livello intermedio - C1/C2 Livello avanzato)",
                    "items" : {
                        "type": "object",
                        "title": "Lingua",
                        "properties": {
                            "titolo": {
                                "type": "string",
                                "title": "Lingua"
                            },
                            "ascolto": {
                                "type": "string",
                                "title": "Ascolto",
                                "oneOf": [
                                    {"const": "A1"},
                                    {"const": "A2"},
                                    {"const": "B1"},
                                    {"const": "B2"},
                                    {"const": "C1"},
                                    {"const": "C2"}
                                ],
                            },
                            "lettura": {
                                "type": "string",
                                "title": "Lettura",
                                "oneOf": [
                                    {"const": "A1"},
                                    {"const": "A2"},
                                    {"const": "B1"},
                                    {"const": "B2"},
                                    {"const": "C1"},
                                    {"const": "C2"}
                                ],
                            },
                            "interazione": {
                                "type": "string",
                                "title": "Interazione",
                                "oneOf": [
                                    {"const": "A1"},
                                    {"const": "A2"},
                                    {"const": "B1"},
                                    {"const": "B2"},
                                    {"const": "C1"},
                                    {"const": "C2"}
                                ],
                            },
                            "orale": {
                                "type": "string",
                                "title": "Produzione orale",
                                "oneOf": [
                                    {"const": "A1"},
                                    {"const": "A2"},
                                    {"const": "B1"},
                                    {"const": "B2"},
                                    {"const": "C1"},
                                    {"const": "C2"}
                                ],
                            },
                            "scritta": {
                                "type": "string",
                                "title": "Produzione Scritta",
                                "oneOf": [
                                    {"const": "A1"},
                                    {"const": "A2"},
                                    {"const": "B1"},
                                    {"const": "B2"},
                                    {"const": "C1"},
                                    {"const": "C2"}
                                ],
                            },



                        }
                    }
                }
            }
        },
        "situazioneAttuale":{
            "type":"object",
            "title": "Situazione Attuale",
            "description": "Completare i campi richiesti",
            "properties":{
                "attualmente":{
                    "type": "string",
                    "title": "Attualmente...",
                    "enum": [
                        "Occupato",
                        "Disoccupato",
                        "Inoccupato"
                    ]
                },
                "apprendistaDal":{
                    "type": "string",
                    "format": "date",
                    "title": "APPRENDISTA: assunto dal"
                },
                "apprendistaAl":{
                    "type": "string",
                    "format": "date",
                    "title": "al"
                },
                "centroImpiedoDi":{
                    "type": "string",
                    "title": "ISCRIZIONE AL CENTRO PER L'IMPIEGO DI"
                },
                "centroImpiedoData":{
                    "type": "string",
                    "format": "date",
                    "title": "al"
                },
                "competenzeInformatiche":{
                    "type": "string",
                    "title": "Competenze Informatiche"
                },
                "softSkills":{
                    "type": "string",
                    "title": "Soft Skills"
                },
                "interessi":{
                    "type": "string",
                    "title": "Hobby e interessi"
                },
                "curriculumVitae":{
                    "format": "data-url",
                    "type": "string",
                    "title": "Curriculum vitae formato Europass, in lingua inglese",
                    "description": "Curriculum vitae formato Europass, in lingua inglese"
                }
            },
            "required":[
                "curriculumVitae"
            ]
        },
        "informazioniAggiuntive":{
            "type":"string",
            "title":"Specificare qui eventuali problemi di salute (allergie, intolleranze, patologie, ecc.)"
        },
        "contattoPerNecessita":{
            "type":"object",
            "title": "Persone da contattare in caso di necessità",
            "properties" : {
                "nomeContatto":{
                    "type": "string",
                    "title": "Nome"
                },
                "cognomeContatto":{
                    "type": "string",
                    "title": "Cognome"
                },
                "parentelaContatto":{
                    "type": "string",
                    "title": "Grado di parentela"
                },
                "indirizzoContatto":{
                    "type": "string",
                    "title": "Indirizzo"
                },
                "telefonoCellulareContatto": {
                    "type": "number",
                    "title": "Telefono Cellulare",
                    "default" : 39,
                },
            },
            "required":[
                "telefonoCellulareContatto"
            ]
        },
        "consensoPresaVisione":{
            "type":"boolean",
            "title":"Presa Visione, Dichiaro di aver preso visione dell’informativa relativa al trattamento denominato: “Progetti di mobilità transnazionale, tirocini formativi, formazione sul campo (WBL) e inserimentolavorativo”"
        },
        "trattamentoDatiPersonali":{
            "type":"object",
            "title":"CONSENSO AL TRATTAMENTO DEI DATI PERSONALI",
            "properties" : {
                "a":{
                    "type":"boolean",
                    "title": "a) Consenso per la finalità di: Attività promozionali - Invio di materiale informative e/o pubblicitario su nuovi servizi e/o prodotti per via telefonica, cartacea o tramite internet:- Invio promozioni e comunicazioni commerciali via telefono, sms, whatsapp, e-mail, newsletter. CONSENSO FACOLTATIVO"
                },
                "b":{
                    "type":"boolean",
                    "title": "b) Consenso per la finalità di: Comunicazione a terzi di informazioni sullo stato di salute - Finalità di archiviazione e comunicazione ai partner nazionali e transnazionali e/o a soggetti terzi dei dati sanitari e delle patologie degli interessati (es. allergie, terapie in corso, ecc.) per salvaguardare la salute degli stessi:- Archiviazione e comunicazione a terzi di dati sanitari e patologie degli interessati. CONSENSO FACOLTATIVO"
                },
                "c":{
                    "type":"boolean",
                    "title": "c) Consenso per la finalità di: Comunicazioni a terzi - Finalità di comunicazione dei dati ad enti istituzionali, partner nazionali o esteri, istituti scolastici (ove applicabili), aziende per tirocini, agenzie di viaggi, compagnie aeree e compagnie assicurative per gestire la mobilità transnazionale, tirocini formativi, formazione sul campo (WBL) e inserimento lavorativo:- Comunicazione dei dati a enti istituzionali, partner nazionali e transnazionali, istituti scolastici (ove applicabile), aziende per tirocini e inserimento lavorativo, agenzie di viaggi e compagnie aeree;- Comunicazione ad assicurazioni private per acquisto pacchetti di assicurazione relativi ai partecipanti. CONSENSO OBBLIGATORIO AI FINI DELLA CANDIDATURA"
                },
                "d":{
                    "type":"boolean",
                    "title": "d) Consenso per la finalità di: Monitoraggio delle attività - Finalità di monitoraggio, rendicontazione e valutazione delle attività di mobilità transnazionale, tirocini formativi, formazione sul campo (WBL) e inserimento lavorativo:- Monitoraggio, valutazione delle attività e follow up;- Comunicazione dell'avanzamento delle attività agli enti istituzionali UE, ai partner nazionali o transnazionali e/o agli istituti scolastici (ove applicabili).CONSENSO OBBLIGATORIO AI FINI DELLA CANDIDATURA"
                },
                "e":{
                    "type":"boolean",
                    "title": "e) Consenso per la finalità di: Comunicazioni in caso di emergenza - Finalità di comunicazioni con i contatti segnalati dall'interessato in caso di emergenze che lo coinvolgano:- Comunicazione con persone da contattare in caso di emergenze. CONSENSO FACOLTATIVO"
                },
                "f":{
                    "type":"boolean",
                    "title": "f) Consenso per la finalità di: Promozione del progetto e delle attività - Finalità di pubblicazione per promuovere e realizzare i risultati dei progetti di mobilità transnazionale, tirocini formativi, formazione sul campo (WBL) e inserimento lavorativo:- Pubblicazione di dati dei partecipanti, dei materiali prodotti nell'ambito del progetto, dei materiali fotografici e audiovisivi che ritraggono gli interessati su piattaforme del titolare, social network, web, pubblicazioni editoriali ecc. o da cedere a terzi per finalità promozionali;- Pubblicazione su social network delle immagini inviate dai partecipanti (il partecipante si assume la responsabilità di ottenere il consenso alla pubblicazione delle foto relativamente a tutte le persone presenti e riconoscibili nelle immagini e/o nei video ).CONSENSO FACOLTATIVO"
                },
                "g":{
                    "type":"boolean",
                    "title":"g) Consenso per la finalità di: Mobilità transnazionale, tirocini formativi, formazione sul campo (WBL) e inserimento lavorativo:- Ricezione domande di partecipazione, valutazione e selezione;- Tutoring e interazione anche mediante strumenti digitali quali e-mail, whatsapp, sms, chat, forum ecc.;-Gestione della logistica;- Archiviazione dei registri delle attività e delle valutazioni finali;- Formazione in aula o fad;- Individuazione bisogni formativi;-Rilascio attestati o qualifiche;- Gestione tirocini aziendali;- Gestione dei rapporti con le aziende;- Inserimento lavorativo;- Comunicazione ad assicurazioni private per acquisto pacchetti di assicurazione;- Svolgimento attività di segreteria;- Amministrazione e manutenzione degli archivi informatici;- Pagamento dei pocket money (ove applicabile); CONSENSO OBBLIGATORIO AI FINI DELLA CANDIDATURA"
                },
            },
            "required":[
                "c","d","g"
            ]
        }
    },
    "required":[
        "background",
        "paeseDestinazione",
        "consensoPresaVisione"

    ]
}
const uiSchema = {
    "ui:order": [
        "*",
        "dataAttuale",

    ],
    "anagrafica":{
      "ui:order":[
          "*",
          "paeseNascita",
          "regioneNascita",
          "provinciaNascita",
          "paeseResidenza",
          "regioneResidenza",
          "provinciaResidenza"
      ],
        "telefonoCellulare": {
            "inputType": 'tel'
        },
        "cap": {
            "inputType": 'number'
        }
    },
    "background": {
        "ui:widget": "radio"
    },"paeseDestinazione": {
        "ui:widget": "checkboxes"
    },
    "domandaMaggiorenne": {
        "maggiorenne": {
            "ui:widget": "radio",
            "ui:help": "Se no, inserisci l'allegato del consenso dei genitori"
        },
        "consenso": {
            "ui:help": "Consenso dei genitori (.pdf, .doc, .docx, .jpg, .jpeg, .png)",
            "ui:options": {
                "accept": ".pdf, .doc, .docx, .jpg, .jpeg, .png"
            }
        }
    },
    "dataAttuale":{
        "ui:readonly": true
    },
    "codiceFiscale": {
        "ui:help": "Con le lettere maiuscole"
    },
    "competenzeInformatiche": {
        "ui:help": "Inserire programmi, software, linguaggi, pacchetti o altro di cui si ha conoscenza e/o indicare relative certificazioni"
    },
    "curriculumVitae": {
        "ui:help": "cv"
    }

}

function customValidate(formData, errors) {
    if (formData.anagrafica.dataNascita > formData.dataAttuale) {
        errors.dataNascita.addError("Devi essere nato almeno ieri");
        errors.message = "Devi essere nato almeno ieri";
    }
    if (formData.dataEmissioneDocumentoEspatrio > formData.dataScadenzaDocumentoEspatrio) {
        errors.dataEmissioneDocumentoEspatrio.addError("Data errata");
        errors.message = "Non puoi registrare un documento scaduto";
    }
    return errors;
}

function transformErrors(errors) {
    return errors.map(error => {
        if (error.name === "required") {
            error.message = "è necessario";
        }
        return error;
    });
}

const onError = (errors) => console.log("I have", errors, "errors to fix");

function TestForm() {
        return (
            <div className="divForm">
                <Form
                    schema={schema}
                    uiSchema={uiSchema}
                    validator={validator}
                    customValidate={customValidate}
                    onError={onError}
                    onSubmit={onSubmit}
                    transformErrors={transformErrors}
                    showErrorList={false}
                    liveValidate
                />


            </div>
        );
}

export default TestForm;